import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import { EventListByType } from './App/Events/Events/EventListByType/EventListByType'
import { EventDetail } from './App/Events/Events/EventDetail/EventDetail'
import { EventSearch } from './App/Events/Events/EventSearch/EventSearch'
import  NewOrder  from './App/Orders/NewOrder/NewOrder'
import { EventTypeEnum } from './Models/Event/EventTypeEnum'

interface IOrderProps {

}

export const OrderApp: React.FunctionComponent<IOrderProps> = (props) => {
    return (
        <div>
            <Routes>               
                <Route path="/events/seach" element={<EventSearch />} />                
                <Route path="/events/detail" element={<EventDetail />} />                
                <Route path="/events" element={<EventSearch />} />
                <Route path="/tabory" element={<EventListByType type={EventTypeEnum.Camp} />} />
                <Route path="/skoleni" element={<EventListByType type={EventTypeEnum.Training} />} />
                <Route path="/" element={<EventListByType type={EventTypeEnum.Camp} />} />  
                <Route path="/events/order" element={<NewOrder />} />                
            </Routes>
        </div>
    )
}
